import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import "./index.css";
import App from "./App.tsx";

const app = (
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);

const rootEl = document.getElementById("root")!;
if (rootEl.hasChildNodes()) {
  // Static HTML is kept for crawlers and first paint, then replaced with the
  // interactive app during idle time. This avoids recoverable hydration
  // mismatches from generated storefront HTML while preserving prerendered SEO.
  const mount = () => {
    rootEl.replaceChildren();
    createRoot(rootEl).render(app);
  };
  if ("requestIdleCallback" in window) {
    requestIdleCallback(mount, { timeout: 3000 });
  } else {
    setTimeout(mount, 200);
  }
} else {
  createRoot(rootEl).render(app);
}
